import React,{ useLayoutEffect, useRef } from 'react'
import './couple.css'
import { gsap } from 'gsap'
const Nophotocouple = ({details}) => {

   const sectionRef = useRef(null)
    const topFrameRef = useRef(null)
    const bottomFrameRef = useRef(null)

       useLayoutEffect(() => {
    
        const ctx = gsap.context(() => {
    
          if (!sectionRef.current) return
    
          const topFrame = topFrameRef.current
          const bottomFrame = bottomFrameRef.current
    
          if (!topFrame && !bottomFrame) return
    
          const frames = [
            topFrame,
            bottomFrame
          ].filter(Boolean)
    
          gsap.from(frames, {
            autoAlpha: 0,
            y: (index) => index === 0 ? -8 : 8,
            duration: 1.1,
            stagger: 0.08,
            ease: "power2.out",
    
            scrollTrigger: {
              trigger: sectionRef.current,
              start: "top 65%",
              once: true,
            },
          })
    
        }, sectionRef)
    
        return () => ctx.revert()
    
      }, [])
  

   const renderPersonCard = ({
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  }) => {
    return (
      <div className="t2-single-couple-container" data-aos="fade-up">

        <div className="t2-couple-grandparents">
          {grandParentsName && (
  <p>
    {grandParentsPrefix} {grandParentsName}
  </p>
)}
        </div>

        <h1 className="t2-couple-name">
          {fullname}
        </h1>

        <div className="t2-couple-parents">
        {parentsName && (
  <p>
    {parentprefix} {parentsName}
  </p>
)}
        </div>

      </div>
    );
  };

   const groomCard = () =>
    renderPersonCard({
      fullname: details?.groomFullName || "Groom Full Name",
      parentprefix: details?.groomParentsPrefix,
      parentsName: details?.groomParents,
      grandParentsPrefix: details?.groomGrandParentsPrefix,
      grandParentsName: details?.groomGrandParents,
    });

  const brideCard = () =>
    renderPersonCard({
      fullname: details?.brideFullName || "Bride Full Name",
      parentprefix: details?.brideParentsPrefix,
      parentsName: details?.brideParents,
      grandParentsPrefix: details?.brideGrandParentsPrefix,
      grandParentsName: details?.brideGrandParents,
    });




  return (
     <section className="couple-section no-photo-couple theme2" ref={sectionRef}>
        <img  ref={topFrameRef} src="/t2-nophotocoupleframe.png" className='t2-couple-frame-border t2-couple-frame-border-top' alt="" />
            <img ref={bottomFrameRef} src="/t2-nophotocoupleframe.png" className='t2-couple-frame-border t2-couple-frame-border-bottom' alt="" />
               
               <div className="t2-couple-inner">
                <h1 className='t2-couple-heading' data-aos="fade-up">  {details?.sectionHeading}</h1>
                  <div className="t2-couple-wrapper">
                   {details?.displayOrder === "groomFirst" ? (
                    <>
                      {groomCard()}
                          <span className="t2-couple-divider" data-aos="fade-up">
                        &
                    </span>
                    {brideCard()}
                    </>
                   ) : ( <>
                       {brideCard()}
                         <span className="t2-couple-divider" data-aos="fade-up">
                        &
                    </span>
                    {groomCard()}
                   </>) }
                  </div>
                  </div>
     </section>
  )
}

export default Nophotocouple